export const MATRIX_GREEN = '#93FF18';
export const MATRIX_GREEN_DIM = '#5A9E0E';
export const MATRIX_DARK = '#080809';
export const MATRIX_BLUE = '#2ECDFF';
export const MATRIX_RED = '#2ECDFF';
export const MATRIX_GRAY = '#929298';
export const MATRIX_CODE_BG = '#0A0F0A';
export const MATRIX_TERMINAL_BG = '#0C120C';
export const TEXT_LIGHT = '#E5E7EB';

export const EASE_OUT = [0.25, 0.46, 0.45, 0.94] as const;
export const EASE_IN_OUT = [0.42, 0, 0.58, 1] as const;

export const MATRIX_CHARS = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン0123456789PINGSERVERLAGNOPING';

export const RED_PILL_STATS = [
  { stat: '180ms+', label: 'Average Ping' },
  { stat: '15-30%', label: 'Packet Loss' },
  { stat: 'Constant', label: 'Rubberbanding' },
  { stat: 'Random', label: 'FPS Drops' },
  { stat: 'Frequent', label: 'Disconnections' },
  { stat: 'RAGE', label: 'Emotional State' },
] as const;

export const GREEN_PILL_STATS = [
  { stat: '9ms', label: 'Average Ping' },
  { stat: '0%', label: 'Packet Loss' },
  { stat: 'None', label: 'Rubberbanding' },
  { stat: '+110%', label: 'FPS Boost' },
  { stat: 'Zero', label: 'Disconnections' },
  { stat: 'VICTORY', label: 'Emotional State' },
] as const;

export const RED_TERMINAL_LINES = [
  { label: 'PING', value: '180ms', status: 'CRITICAL' },
  { label: 'LOSS', value: '4.2%', status: 'DEGRADED' },
  { label: 'JITTER', value: '45ms', status: 'UNSTABLE' },
] as const;

export const GREEN_TERMINAL_LINES = [
  { label: 'PING', value: '9ms', status: 'OPTIMAL' },
  { label: 'PACKET_LOSS', value: '0.0%', status: 'CLEAN' },
  { label: 'JITTER', value: '1ms', status: 'STABLE' },
  { label: 'ROUTES_ACTIVE', value: '5/5', status: 'ONLINE' },
] as const;

export const MULTI_INTERNET_LINES = [
  { label: 'ISP_PRIMARY', value: 'CONNECTED', status: 'ONLINE' },
  { label: 'ISP_SECONDARY', value: 'CONNECTED', status: 'STANDBY' },
  { label: 'BACKUP_ROUTES', value: '10/10', status: 'READY' },
  { label: 'FAILOVER', value: 'AUTOMATIC', status: 'ARMED' },
  { label: 'PACKET_LOSS', value: '0.00%', status: 'PROTECTED' },
] as const;

export const MC_ROUTES = [
  { server: 'CHICAGO 112', hops: [{ label: '2ms' }, { label: '8ms' }], y: 40 },
  { server: 'DALLAS 113', hops: [{ label: '3ms' }, { label: '12ms' }], y: 105 },
  { server: 'DENVER 92', hops: [{ label: '4ms' }, { label: '18ms' }], y: 170 },
  { server: 'SEATTLE 90', hops: [{ label: '3ms' }, { label: '22ms' }], y: 235 },
  { server: 'ATLANTA 96', hops: [{ label: '5ms' }, { label: '15ms' }], y: 300 },
] as const;

export const GLOBAL_KEYFRAMES = `
  @keyframes glitch-clip-red {
    0%, 92%, 100% { opacity: 0; }
    93% { opacity: 0.7; clip-path: inset(15% 0 55% 0); transform: translate(-3px, 1px); }
    94% { opacity: 0; }
    95% { opacity: 0.5; clip-path: inset(40% 0 30% 0); transform: translate(-2px, -1px); }
    96% { opacity: 0; }
  }
  @keyframes glitch-clip-blue {
    0%, 91%, 100% { opacity: 0; }
    92% { opacity: 0.6; clip-path: inset(60% 0 10% 0); transform: translate(3px, -1px); }
    93.5% { opacity: 0; }
    94.5% { opacity: 0.5; clip-path: inset(20% 0 50% 0); transform: translate(2px, 1px); }
    96% { opacity: 0; }
  }
  @keyframes float-up {
    0% { transform: translateY(0) rotate(0deg); opacity: 0; }
    10% { opacity: 0.6; }
    90% { opacity: 0.3; }
    100% { transform: translateY(-100vh) rotate(20deg); opacity: 0; }
  }
  @keyframes glow-pulse-ring {
    0%, 100% { box-shadow: 0 0 15px #93FF1830, 0 0 30px #93FF1815, inset 0 0 15px #93FF1810; }
    50% { box-shadow: 0 0 25px #93FF1850, 0 0 50px #93FF1825, inset 0 0 25px #93FF1815; }
  }
  @keyframes cta-glow {
    0%, 100% { box-shadow: 0 0 20px #93FF1840, 0 0 40px #93FF1820; }
    50% { box-shadow: 0 0 30px #93FF1860, 0 0 60px #93FF1830, 0 0 80px #93FF1815; }
  }
`;
